export interface LayoutState {
    profile_update_modal_visibility: boolean
    location_update_modal_visibility: boolean,
    main_menu_visibility: boolean
    page_title: string
    intended_path: string
    selected_post_id: string | null
    bg_white: boolean
    address_selection_modal_visibility: boolean
    showFooterNav: boolean,
    showHeader: boolean,
    collabSupport: {
        visibility: {
            icon: boolean,
            popup: boolean
        },
    },
    selectedSocialPost: {
        socialPostId: string,
        socialAccountId: string
    } | null,
    add_social_account_modal_visibility: {
        platforms: {
            id: string,
            name: string
        }[],
        active: boolean
    },
    enable_notifications_popup_visibility: boolean,
    header: AppHeaderProps | null,
    pro_features_modal_visibility: boolean
}

export interface AppHeaderProps {
    generic: boolean,
    page?: any,
    [key: string]: any
}

export const defaultAppHeaderProps: AppHeaderProps = {
    generic: true,
}